import { UpsertContentMarketplaceMeta, UpsertContentMarketplacePayload } from 'types/store/UpsertContentMarketplace';
import { createAsyncReducer } from 'utils/Redux';

import { upsertContentMarketplaceActions } from '../actions';

export default createAsyncReducer<UpsertContentMarketplaceMeta, UpsertContentMarketplacePayload>(upsertContentMarketplaceActions);
